import {components, type ControlProps} from 'react-select';

import styled, {css} from 'styled-components';

import type {SelectV2} from '../Select.v2';

import {getColor, ms} from '../../../../styles';
import {getSelectSizeStyles} from '../Select.v2.styles';
import {ThemeForwardingWrapper} from './SelectThemeForwarding.v2';

const ForwardedWrapper = ({forwardTheme, ...props}) => (
  <ThemeForwardingWrapper
    Component={components.Control}
    forwardTheme={forwardTheme}
    {...props}
  />
);

const containerBorder = css<SelectControlV2.Props>`
  border-width: ${ms(1)};
  border-style: solid;
  border-color: ${p => {
    switch (true) {
      case p.error:
        return getColor('error');
      case p.menuIsOpen:
        return getColor('border.primary');
      default:
        return getColor('border2');
    }
  }};
`;

export const SelectControlV2 = styled(ForwardedWrapper)<SelectControlV2.Props>`
  && {
    cursor: pointer;
    box-sizing: border-box;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    color: ${getColor('text.black')};
    transition: all ease 0.2s;
    box-shadow: none;
    background-color: ${p =>
      p.theme.id === 'light'
        ? getColor('background1')
        : getColor('background2')};

    ${p => getSelectSizeStyles(p)};
    ${containerBorder};
    &:hover {
      ${containerBorder}
    }
  }
`;

export namespace SelectControlV2 {
  export type Props = ControlProps &
    Required<Pick<SelectV2.Props, 'size'>> &
    Pick<SelectV2.Props, 'error'>;
}
